import { Link } from 'react-router-dom';
import './style.scss';

const visitOptions = [
  {
    title: 'Visualizar visitas',
    description: 'Consulta las visitas registradas a actividades en territorio.',
    icon: 'visibility',
    to: '/administrador/visitas-territorio/visualizar'
  },
  {
    title: 'Registrar visita',
    description: 'Registra una nueva visita a una actividad en territorio.',
    icon: 'add_location_alt',
    to: '/administrador/visitas-territorio/registrar'
  }
];

export default function TerritoryVisitsMenu() {
  return (
    <section className='territory-visits-menu'>
      <div className='territory-visits-menu__content'>
        <h1>Visitas a actividades en territorio</h1>
        <div className='territory-visits-menu__options'>
          {visitOptions.map(option => (
            <Link
              key={option.to}
              to={option.to}
              className='territory-visits-menu__card'>
              <div className='territory-visits-menu__icon'>
                <span
                  className='material-symbols-rounded'
                  aria-hidden='true'>
                  {option.icon}
                </span>
              </div>
              <p>{option.description}</p>
              <h2>{option.title}</h2>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}

export function TerritoryVisitsPlaceholder({ title }) {
  return (
    <section className='territory-visits-placeholder'>
      <div>
        <h1>{title}</h1>
        <p>Este módulo está listo para continuar su desarrollo.</p>
      </div>
    </section>
  );
}
